module.exports = __webpack_public_path__ + "static/media/0110_IMG_LA_BERGERIE_SANS.3e3f8957.png";